export { localize } from './Localize';
export { Translate } from './Translate';

export { localeReducer, initialize, addTranslation, addTranslationForLanguage, setLanguages, setActiveLanguage, getTranslate, getActiveLanguage, getLanguages, getTranslations, getOptions } from './locale';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-localize-redux/es/index.js
// module id = 4
// module chunks = 0